<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible_"
      ref="dialog"
      width="662rem"
      :title="title"
      @closed="closeDialog"
    >
      <div class="body">
        <el-form :model="form" label-width="50rem" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="16" class="left_col">
              <el-form-item label="题源：" prop="bookTypeId" label-width="60px">
                <el-cascader
                  :options="options"
                  v-model="form.bookTypeId"
                  clearable
                  popper-class="left_cascader"
                  :props="{ expandTrigger: 'hover' }"
                  placeholder="请选择题源"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item
                label="年份："
                class="year"
                prop="year"
                label-width="60px"
              >
                <el-date-picker
                  v-model="form.year"
                  type="year"
                  size="small"
                  popper-class="left_year"
                  value-format="yyyy"
                  class="custom-date-picker-selection"
                  :picker-options="pickerOptions"
                  placeholder="选择年"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                label="年级："
                class="grade"
                prop="grade"
                label-width="60px"
              >
                <el-select v-model="form.grade" placeholder="请选择年级">
                  <el-option
                    v-for="(item, index) in gradeList"
                    :key="'grade'+index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="册别："
                class="bookVersion"
                prop="bookVersion"
                label-width="60px"
                v-if="form.grade != '中考'"
              >
                <el-select v-model="form.bookVersion" placeholder="请选择册别">
                  <el-option
                    v-for="(item, index) in versionList"
                    :key="'version'+index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item
                    label="年级："
                    class="grade"
                    prop="grade"
                    label-width="60px"
                  >
                    <el-select v-model="form.grade" placeholder="请选择年级">
                      <el-option
                        v-for="item in gradeList"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="册别："
                    class="bookVersion"
                    prop="bookVersion"
                    label-width="60px"
                  >
                    <el-select
                      v-model="form.bookVersion"
                      placeholder="请选择册别"
                    >
                      <el-option
                        v-for="item in versionList"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-form-item label="启用：" label-width="60px">
                <el-switch
                  v-model="form.status"
                  active-color="#0BAE6A"
                  inactive-color="#eeeeee"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="right_col">
              <el-form-item label="封面：" prop="cover">
                <el-upload
                  v-show="!progressFlag && !previewImageShow && !failedFlag"
                  ref="upload"
                  :limit="1"
                  class="upload"
                  :on-change="handleEditChange"
                  :http-request="ImgUploadSectionFile"
                  :before-upload="beforeAvatarUpload"
                  list-type="picture-card"
                  :file-list="fileList"
                  action="#"
                >
                  <!-- <div style="line-height: unset;"> -->
                  <!-- 加号标识 -->
                  <i slot="default" class="el-icon-plus"></i>
                  <div class="el-upload__text">上传图片</div>
                  <div class="el-upload__tip" slot="tip" v-if="tipVisible">
                    仅支持.jpg/png格式
                  </div>
                  <!-- 上传后显示 -->
                  <div
                    slot="file"
                    slot-scope="{ file }"
                    class="el-upload-items"
                  >
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url"
                    />
                    <div class="el-upload-list__item-actions upload_option">
                      <!-- 图片放大 -->
                      <div
                        class="upload_option_preview"
                        @click="handlePictureCardPreview(file)"
                      >
                        <i class="el-icon-zoom-in"></i>
                        <span>预览</span>
                      </div>
                      <!-- 图片删除 -->
                      <div
                        class="upload_option_delete"
                        @click="handleRemove(file)"
                      >
                        <i class="el-icon-delete"></i>
                        <span>删除</span>
                      </div>
                    </div>
                  </div>
                  <!-- </div> -->
                </el-upload>
                <!--上传中-->
                <div v-if="progressFlag" class="progress_box">
                  <el-progress
                    v-if="progressFlag"
                    color="#0BAE6A"
                    text-color="#303133"
                    :percentage="progressPercent"
                  ></el-progress>
                  <p>上传中...</p>
                </div>

                <!--题源回显编辑图片-->
                <div v-if="previewImageShow" class="progress_box">
                  <img style="height: 100%; width: 100%" :src="form.cover" />
                  <div class="upload_option edit_preview">
                    <!-- 图片放大 -->
                    <div
                      class="upload_option_preview"
                      @click="handlePictureCardPreview(form)"
                    >
                      <i class="el-icon-zoom-in"></i>
                      <span>放大</span>
                    </div>
                    <!-- 图片删除 -->
                    <div class="upload_option_delete" @click="handleRemove()">
                      <i class="el-icon-delete"></i>
                      <span>删除</span>
                    </div>
                  </div>
                </div>
                <!--上传失败-->
                <div v-if="failedFlag" class="progress_box_failed">
                  <!-- <i class="el-icon-delete"></i> -->
                  <span class="span_1">上传失败</span>
                  <span class="span_2">请检查格式或网络</span>
                  <el-button
                    icon="el-icon-refresh-left"
                    plain
                    size="mini"
                    @click="reUpload"
                    >重试</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="bottom">
        <el-button
          :disabled="btnDisabled"
          size="mini"
          @click="save"
          :class="{ saveBtn: btnDisabled }"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <!--图片预览-->
    <el-dialog
      title="图片预览"
      :visible.sync="previewVisible"
      width="50%"
      height="50%"
      class="preview_dia"
    >
      <img
        :src="previewPath"
        alt=""
        style="width: 50%; height: 100%"
        class="img"
      />
    </el-dialog>
  </div>
</template>
<script>
import { uploadUrl } from "@/constants/constants";
import { getToken } from "@/utils/auth";
export default {
  name: "newQuestionDia",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    book: {
      type: Object,
      default: () => {},
    },
    gradeList: Array,
    versionList: Array,
  },

  computed: {
    dialogVisible_: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("dialogClose", val);
      },
    },
  },
  mounted() {
    this.options = this.$attrs.option;
  },
  watch: {
    form: {
      handler(val) {
        if (val.bookTypeId.length > 0 && val.year && val.cover) {
          this.btnDisabled = false;
        } else {
          this.btnDisabled = true;
        }
      },
      deep: true,
      immediate: true,
    },
    book: {
      handler(val) {
        console.log('val: ', val);
        if (val != undefined) {
          this.form.bookTypeId = val.bookTypeIdNodes;
          this.form.year = val.year;
          this.form.cover = val.cover;
          this.form.status = val.status === "0" ? true : false;
          this.form.grade = val.grade;
          this.form.bookVersion = val.bookVersion;
        }
      },
      deep: true,
      immediate: true,
    },
    dialogVisible_: {
      handler(val) {
        if (val && this.form.cover) {
          this.previewImageShow = true;
        }
      },
    },
  },
  data() {
    return {
      customHeaders: {
        Authorization: getToken(),
      },
      progressFlag: false,
      failedFlag: false,
      progressPercent: 0,
      btnDisabled: false,
      previewPath: "",
      previewImageShow: false,
      previewVisible: false,
      uploadAudioUrl: uploadUrl,
      reUploadData: {},
      pickerOptions: {
        disabledDate: (time) => {
          let year = time.getFullYear();
          let dataRange = [2024, 2025, 2026, 2027, 2028, 2029, 2030];
          return !dataRange.includes(year);
        },
      },
      form: {
        bookTypeId: [],
        year: "",
        cover: "",
        grade: "",
        bookVersion: "",
        status: true,
      },
      fileList: [],
      tipVisible: true,
      hideUploadEdit: false,
      options: [],
      rules: {
        bookTypeId: [
          { required: true, message: "请选择题源", trigger: "blur" },
        ],
        year: [{ required: true, message: "请选择年份", trigger: "blur" }],
        cover: [{ required: true, message: "请上传封面", trigger: "blur" }],
        grade: [{ required: true, message: "请选择年级", trigger: "blur" }],
        bookVersion: [{ required: true, message: "请选择册别", trigger: "blur" }],
      },
    };
  },
  methods: {
    //关闭对话框重置表单
    closeDialog() {
      if (this.book === undefined) {
        this.form = {
          bookTypeId: [],
          year: "",
          cover: "",
          status: true,
        };
        this.handleRemove();
      }
    },
    //保存题源
    save() {
      this.$emit("newOrUpdateQuestion", this.form);
      this.dialogVisible_ = false;
      //只有当新增题源时才会重置form
      if (this.book === undefined) {
        this.form = {
          bookTypeId: [],
          year: "",
          cover: "",
          status: true,
        };
        this.handleRemove();
      }
    },

    // 放大图片
    handlePictureCardPreview(file) {
      this.previewPath = file.url ? file.url : file.cover;
      this.previewVisible = true;
    },
    // 删除图片
    handleRemove(file) {
      this.tipVisible = false;
      if (this.fileList.length === 0) {
        this.fileList = [];
      } else {
        let dl = this.fileList.indexOf(file);
        this.fileList.splice(dl, 1);
      }
      this.form.cover = "";
      this.previewImageShow = false;
      setTimeout(() => {
        this.$refs.upload.$children[1].$el.style.display = "";
        this.tipVisible = true;
      }, 100);
    },

    // on-change添加文件，上传成功和上传失败时都会被调用
    handleEditChange() {
      this.$refs.upload.$children[1].$el.style.display = "none";
    },
    // http-request自定义上传
    async ImgUploadSectionFile(data) {
      //保存data 上传失败重试使用
      this.reUploadData = data;
      let url = this.uploadAudioUrl;
      let formdata = new FormData();
      formdata.append("file", data.file);
      const config = {
        onUploadProgress: (progressEvent) => {
          this.progressPercent = Math.ceil(
            Number((progressEvent.loaded / progressEvent.total) * 100)
          );
        },
        headers: {
          Authorization: getToken(),
        },
      };
      this.progressFlag = true;
      let res = await this.$axios.post(url, formdata, config);
      if (res.data.code == 0) {
        this.progressFlag = false;
        this.progressPercent = 0;
        this.form.cover = res.data.data;
      } else {
        //上传失败重新上传
        this.progressFlag = false;
        this.progressPercent = 0;
        this.failedFlag = true;
        this.$refs.upload.$children[1].$el.style.display = "";
      }
    },

    // before-upload上传文件之前的钩子，参数为上传的文件
    // 若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeAvatarUpload(file) {
      const isJPG =
        (file.type === "image/jpeg" || file.type === "image/png") &&
        file.name.split(".")[1].toLowerCase() != "jpeg";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("仅支持.jpg/png格式!");
        //显示上传框
        this.$refs.upload.$children[1].$el.style.display = "";
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过5MB!");
        this.$refs.upload.$children[1].$el.style.display = "";
      }
      return isJPG && isLt2M;
    },

    reUpload() {
      this.failedFlag = false;
      this.ImgUploadSectionFile(this.reUploadData);
    },
  },
};
</script>
<style lang="scss" scoped>
.body {
  background: #ffffff;
  width: 562rem;
//   height: 166rem;
  // min-height: 150px;
  padding: 20rem;
  border-radius: 6rem;
  margin: auto;
  .left_col {
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    ::v-deep .el-input__inner {
      width: 304rem;
    }
  }
  .right_col {
    height: 206rem;
    .upload_option {
      font-size: 12rem;
      .upload_option_preview {
        display: flex;
        align-items: center;
        line-height: 30rem;
        position: absolute;
        justify-content: center;
        top: 30rem;
        right: 10rem;
        background: var(--primary-color);
        height: 30rem;
        width: 80rem;
      }
      .upload_option_delete {
        display: flex;
        align-items: center;
        line-height: 30rem;
        position: absolute;
        justify-content: center;
        top: 65rem;
        right: 10rem;
        background: #ff0000;
        height: 30rem;
        width: 80rem;
      }
    }
    .progress_box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      background: #fff;
      border: 1rem dashed #a8aeb6;
      border-radius: 4rem;
      width: 108rem;
      height: 125rem;
      .edit_preview {
        position: absolute;
        width: 88%;
        height: 100%;
        left: 0;
        top: 0;
        // cursor: default;
        text-align: center;
        color: #fff;
        opacity: 0;
        background-color: rgba(0, 0, 0, 0.5);
        transition: opacity 0.3s;
        // &::after {
        //     display: inline-block;
        //     content: "";
        //     height: 100%;
        //     vertical-align: middle
        // }
        &:hover {
          opacity: 1;
          display: inline-block;
        }
      }

      .el-progress {
        margin-top: 20rem;
      }
      p {
        font-size: 10rem;
        color: #a8aeb6;
      }
    }
    .progress_box_failed {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      align-items: center;
      background: #fff;
      border: 1rem dashed #a8aeb6;
      border-radius: 4rem;
      width: 108rem;
      height: 125rem;
      .span_1 {
        font-size: 12rem;
        margin-bottom: -15rem;
      }
      .span_2 {
        font-size: 10rem;
        color: #a8aeb6;
      }
      .span_1::before {
        content: url(../static/error.png);
        position: relative;
        top: 2rem;
        left: -2rem;
      }
      .el-button {
        width: 80rem;
        height: 28rem;
        border-radius: 4rem;
        color: var(--primary-color);
        font-size: 12rem;
        border-color: var(--primary-color);
      }
    }
  }

  ::v-deep .el-input__inner:hover,
  ::v-deep .el-input__inner:focus {
    border-color: var(--primary-color);
  }
}

.bottom {
  height: 60rem;
  .el-button {
    float: right;
    width: 76rem;
    height: 32rem;
    position: relative;
    bottom: 0rem;
    right: 10rem;
    color: #fff;
    background: var(--primary-color);
    font-size: 16rem;
    border: none !important;
  }
  .saveBtn {
    background: #b7e7d3;
  }
}

// ::v-deep .el-dialog {
//   height: 340rem !important;
// }
//图片预览样式
::v-deep .preview_dia {
  .el-dialog {
    background: rgba(0, 0, 0, 0) !important;
    margin: 0 !important;
    top: 180rem !important;
    width: 80% !important;
    border: none !important; /* 去除边框 */
    box-shadow: none !important; /* 再次确保去除阴影 */
  }

  .el-dialog__wrapper {
    box-shadow: none !important; /* 去除阴影 */
  }
  .el-dialog__header .el-dialog__close,
  .el-dialog__header .el-dialog__close:hover,
  .el-dialog__title {
    color: #fff !important;
  }
  .img {
    margin-left: 28%;
  }
}

::v-deep .el-upload-list__item {
  transition: none !important;
  -webkit-transition: none !important;
}
::v-deep .el-upload-list__item-name {
  transition: none !important;
  -webkit-transition: none !important;
}
//解决图片上传下方文字偏移
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  display: block;
  overflow: auto;
  margin-top: -1rem;
}
::v-deep .el-upload,
::v-deep .el-upload-items,
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  width: 108rem;
  height: 125rem;
  position: relative;
}
::v-deep .el-upload:hover,
::v-deep .el-upload:focus {
  border-color: var(--primary-color);
}
.el-icon-plus {
  transform: scale(0.8, 0.8);
  color: #a8aeb6;
  // position: relative;
  // top:-10rem;
  position: absolute;
  top: 30rem;
  line-height: 30rem;
  left: 0;
  right: 0;
  margin: auto;
}
.el-upload__tip {
  position: relative;
  top: -10rem;
  font-size: 12rem;
}
.el-upload__text {
  // position: relative;
  // top:-140rem;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 20rem;
  color: #a8aeb6;
  font-size: 10rem;
  height: 30rem;
  line-height: 30rem;
}
.el-upload__text:hover {
}
::v-deep .left_col .year .el-input__suffix .el-icon-circle-close {
  position: relative;
  right: -85rem;
}
::v-deep .el-dialog__header .el-dialog__title {
  padding-left: 15rem;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    // left: 20rem;
    // top: 22rem;
    left: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    margin: auto !important;
    width: 5rem;
    height: 20rem;
    border-radius: 10rem;
    background-color: var(--primary-color);
  }
}
</style>
<style lang="scss">
.left_cascader {
  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active,
  .el-cascader-node.is-selectable.in-checked-path {
    color: #0bae6a;
  }
}
.left_year {
  .el-picker-panel__icon-btn,
  .el-date-picker__header-label,
  .el-year-table td .cell:hover,
  .el-year-table td.today .cell,
  .el-year-table td.current .cell {
    color: #0bae6a !important;
  }
}
</style>
